import React, { useState } from "react";
import { Alert, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthContext";

type AuthFormsProps = {
  loginReasonKey?: string;
};

/** Google federated sign-in CTA on the auth landing. */
export function AuthForms({ loginReasonKey }: AuthFormsProps) {
  const { t } = useTranslation();
  const auth = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const errorDescription = auth.error
    ? auth.error.source === "i18n"
      ? t(auth.error.key)
      : auth.error.message
    : null;

  const onGoogleSignIn = async () => {
    setSubmitting(true);
    auth.clearError();
    try {
      await auth.signInWithGoogle();
      // Browser navigates away to Cognito / Google; keep button busy if it returns.
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <div className="Auth-form">
      {loginReasonKey && (
        <Alert
          type="info"
          showIcon
          title={t(loginReasonKey)}
          className="Auth-screen__alert"
        />
      )}
      {errorDescription && (
        <Alert
          type="error"
          showIcon
          title={t("auth.errorTitle")}
          description={errorDescription}
          className="Auth-screen__alert"
        />
      )}

      <Button
        type="primary"
        size="large"
        className="Auth-screen__cta"
        loading={submitting}
        disabled={submitting}
        onClick={() => void onGoogleSignIn()}
      >
        {t("auth.googleSignIn")}
      </Button>
    </div>
  );
}
